
"use client"

import { useState, useEffect } from "react"
import { Container, Button } from "react-bootstrap"
import { Link } from "react-router-dom"
import "../components/styles/Hero.css"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"

import s1 from '../assets/productsec/s4.avif'
import s2 from '../assets/productsec/s5.jpeg'
import s3 from '../assets/productsec/s6.avif'

import hb1 from '../assets/SSP/homeBanner1.jpeg'
import hb2 from '../assets/SSP/homeBanner2.jpeg'
import hb3 from '../assets/SSP/homeBanner3.jpeg'
// import hb4 from '../assets/SSP/homeBanner4.jpeg'
// import hb5 from '../assets/SSP/homeBanner5.jpeg'

function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0)
  const slides = [
    {
      title: "EXPERIENCE IMMACULATE CLEANING FOR YOUR HOME & OFFICE",
      image: hb1,
      bgColor: "rgba(92, 128, 202, 0.8)",
    },
    {
      title: "PROFESSIONAL CLEANING SERVICES FOR A HEALTHIER ENVIRONMENT",
      image: hb2,
      bgColor: "rgba(72, 113, 197, 0.8)",
    },
    {
      title: "SANITIZATION & MAINTENANCE SOLUTIONS YOU CAN TRUST",
      image: hb3,
      bgColor: "rgba(84, 128, 214, 0.8)",
    },
  ]

  // Auto-change slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1))
    }, 3000)

    return () => clearInterval(interval)
  }, [])

  // Manual slide navigation
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1))
  }

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1))
  }

  return (
    <section
      className="hero-section"
      style={{
        backgroundImage: `url(${slides[currentSlide].image})`,
      }}
    >
      <div className="hero-overlay" style={{ backgroundColor: slides[currentSlide].bgColor }}></div>
      <Container className="position-relative hero-container">
        <button className="hero-nav hero-nav-prev" onClick={prevSlide}>
          <FaChevronLeft />
        </button>
        <div className="hero-content">
          <h1 className="hero-title">{slides[currentSlide].title}</h1>
          <div className="mt-4">
            <Button as={Link} to="/product" variant="primary" size="lg" className="get-started-btn">
              Get Started Now!
            </Button>
          </div>
        </div>
        <button className="hero-nav hero-nav-next" onClick={nextSlide}>
          <FaChevronRight />
        </button>
      </Container>
    </section>
  )
}

export default Hero
